import { Grid, Typography } from "@mui/material";
import { ContentWrapper } from "@src/components";
import ReadOnlyDetailField from "@src/components/fields/ReadOnlyDetail";
import { type GQLUserLogFragmentFragment } from "@src/graphql.generated";
import { type FC, type PropsWithChildren } from "react";
import { FormattedMessage, useIntl } from "react-intl";

import * as sc from "./LogsInformationDetails.sc";

interface Props {
    data: GQLUserLogFragmentFragment;
}

const LogInformationDetails: FC<PropsWithChildren<Props>> = ({ data }) => {
    const intl = useIntl();

    const items: Array<[string, string]> = Object.entries(data?.data ?? {});

    return (
        <ContentWrapper>
            <Typography variant="h5" color="primary" gutterBottom>
                <FormattedMessage id="reviermanager.logs.details.title" defaultMessage="Protokoll" />
            </Typography>
            {data && (
                <>
                    <ReadOnlyDetailField
                        type="date"
                        value={data.createdAt}
                        label={intl.formatMessage({ id: "reviermanager.userlogs.detail.createdAt", defaultMessage: "Erstellt am" })}
                    />
                    <ReadOnlyDetailField
                        value={data.severityLevel}
                        label={intl.formatMessage({ id: "reviermanager.userlogs.detail.severityLevel", defaultMessage: "Typ" })}
                    />
                    <ReadOnlyDetailField
                        value={data.message}
                        label={intl.formatMessage({ id: "reviermanager.userlogs.detail.message", defaultMessage: "Nachricht" })}
                    />
                    <Typography variant="subtitle1" gutterBottom>
                        <FormattedMessage id="reviermanager.userlogs.detail.data" defaultMessage="Daten" />
                    </Typography>
                    {items.map(([key, value], index) => {
                        return (
                            <sc.StyledDataRow key={index}>
                                <Grid size={4}>
                                    <sc.StyledDataKey>{key}</sc.StyledDataKey>
                                </Grid>
                                <Grid size={8}>{typeof value === "string" ? <Typography>{value}</Typography> : JSON.stringify(value)}</Grid>
                            </sc.StyledDataRow>
                        );
                    })}
                </>
            )}
        </ContentWrapper>
    );
};

export default LogInformationDetails;
